// components/viz/ParityPlot.jsx
// 模型奇偶图（实验值 vs 预测值）

export default function ParityPlot({ diag }) {
  if (!diag) return null;
  const W = 380, H = 380;
  const pad = 50;
  const w = W - 2 * pad, h = H - 2 * pad;
  const max = Math.max(...diag.points.flatMap(p => [p.exp, p.pred])) * 1.05;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: "100%" }}>
      <rect x={pad} y={pad} width={w} height={h} fill="#ffffff" stroke="#cbd5e1" />
      {[0, 0.25, 0.5, 0.75, 1].map(r => (
        <g key={r}>
          <line x1={pad} y1={pad + r * h} x2={pad + w} y2={pad + r * h} stroke="#e2e8f0" />
          <line x1={pad + r * w} y1={pad} x2={pad + r * w} y2={pad + h} stroke="#e2e8f0" />
          <text x={pad - 6} y={pad + (1 - r) * h + 4} textAnchor="end" fontSize="9" fontFamily="'JetBrains Mono',monospace" fill="#64748b">{(r * max).toFixed(2)}</text>
          <text x={pad + r * w} y={pad + h + 14} textAnchor="middle" fontSize="9" fontFamily="'JetBrains Mono',monospace" fill="#64748b">{(r * max).toFixed(2)}</text>
        </g>
      ))}
      {/* y=x */}
      <line x1={pad} y1={pad + h} x2={pad + w} y2={pad} stroke="#0f172a" strokeWidth="1.5" strokeDasharray="4,3" opacity="0.5" />
      {/* ±10% bands */}
      <line x1={pad} y1={pad + h} x2={pad + w * 0.91} y2={pad} stroke="#10b981" strokeWidth="0.8" strokeDasharray="2,3" opacity="0.4" />
      <line x1={pad + w * 0.09} y1={pad + h} x2={pad + w} y2={pad + h * 0.09} stroke="#10b981" strokeWidth="0.8" strokeDasharray="2,3" opacity="0.4" />
      {/* points */}
      {diag.points.map((p, i) => (
        <circle key={i} cx={pad + (p.exp / max) * w} cy={pad + (1 - p.pred / max) * h} r="3" fill="#0ea5e9" opacity="0.55" stroke="#ffffff" strokeWidth="0.8" />
      ))}
      <text x={pad + w / 2} y={H - 12} textAnchor="middle" fontSize="11" fontFamily="'IBM Plex Sans',sans-serif" fontWeight="600" fill="#0f172a">实验值</text>
      <text x={16} y={pad + h / 2} textAnchor="middle" fontSize="11" fontFamily="'IBM Plex Sans',sans-serif" fontWeight="600" fill="#0f172a" transform={`rotate(-90, 16, ${pad + h / 2})`}>预测值</text>
    </svg>
  );
}
